// extracted by mini-css-extract-plugin
export var cardLayout = "_21-1";
export var paginationContainer = "_21-0";